// import React, { useEffect, useState } from "react";
// import { Table, Spinner, Form, Button, Pagination } from "react-bootstrap";
// import axios from "axios";
// import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

// const API_URL = process.env.REACT_APP_API_URL;

// function GiftSelfToAssociateList() {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [filters, setFilters] = useState({
//     mobile: "",
//     bysqrt: "",
//   });

//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     totalPages: 1,
//     totalItems: 0,
//     limit: 20,
//   });

//   const getAuthToken = () => localStorage.getItem("token");

//   const fetchData = async (page = 1, filterData = filters) => {
//     setLoading(true);
//     const token = getAuthToken();

//     if (!token) {
//       alert("Authentication token not found.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const params = {
//         page,
//         limit: pagination.limit,
//         mobile: filterData.mobile || "",
//         buysqrt: filterData.bysqrt || "",
//       };

//       const response = await axios.get(
//         `${API_URL}/gift-self-to-associate-list-given`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//           params,
//         },
//       );

//       if (response.data.status === "1") {
//         setData(response.data.data || []);
//         setPagination((prev) => ({
//           ...prev,
//           currentPage: response.data.pagination.page,
//           totalPages: response.data.pagination.totalPages,
//           totalItems: response.data.pagination.total,
//         }));
//       } else {
//         setData([]);
//         setPagination((prev) => ({
//           ...prev,
//           currentPage: 1,
//           totalPages: 1,
//           totalItems: 0,
//         }));
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//       setData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData(pagination.currentPage);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [pagination.currentPage]);

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleFilterSubmit = (e) => {
//     e.preventDefault();
//     setPagination((prev) => ({ ...prev, currentPage: 1 }));
//     fetchData(1, filters);
//   };

//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const handleToggle = () => setIsFilterActive(!isFilterActive);

//   const handlePageChange = (page) => {
//     if (page > 0 && page <= pagination.totalPages) {
//       setPagination((prev) => ({ ...prev, currentPage: page }));
//     }
//   };

//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               🎁
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "24px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                 }}
//               >
//                 Self Gift To Associate
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 View all self gifts given to associates
//               </p>
//             </div>

//             <button
//               className={`filter-toggle-btn btn ${
//                 isFilterActive ? "active" : ""
//               }`}
//               onClick={handleToggle}
//               style={{
//                 width: "44px",
//                 height: "44px",
//                 borderRadius: "12px",
//                 border: "1.5px solid #e2e8f0",
//                 background: isFilterActive ? "#1e5799" : "#ffffff",
//                 color: isFilterActive ? "#ffffff" : "#1e3a5f",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: "20px",
//                 cursor: "pointer",
//                 transition: "all 0.25s ease",
//                 boxShadow: isFilterActive
//                   ? "0 8px 20px rgba(30, 87, 153, 0.3)"
//                   : "none",
//               }}
//               title={isFilterActive ? "Hide Filters" : "Show Filters"}
//             >
//               {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//             </button>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background:
//                   "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {/* FILTER PANEL */}
//               {isFilterActive && (
//                 <div
//                   style={{
//                     background: "#f8fafc",
//                     border: "1.5px dashed #cbd5e1",
//                     borderRadius: "12px",
//                     padding: "20px",
//                     marginBottom: "24px",
//                   }}
//                 >
//                   <Form
//                     onSubmit={handleFilterSubmit}
//                     className="d-flex gap-2 flex-wrap-mobile"
//                   >
//                     <Form.Control
//                       type="text"
//                       name="mobile"
//                       value={filters.mobile}
//                       onChange={handleFilterChange}
//                       placeholder="Search by Mobile"
//                     />
//                     <Form.Control
//                       type="text"
//                       name="bysqrt"
//                       value={filters.bysqrt}
//                       onChange={handleFilterChange}
//                       placeholder="Search by SQYD"
//                     />
//                     <Button variant="primary" type="submit">
//                       Search
//                     </Button>
//                   </Form>
//                 </div>
//               )}

//               {/* TABLE */}
//               {loading ? (
//                 <div className="text-center my-5">
//                   <Spinner animation="border" />
//                   <p className="mt-3">Loading data...</p>
//                 </div>
//               ) : (
//                 <>
//                   <Table striped bordered hover responsive>
//                     <thead
//                       style={{
//                         background:
//                           "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                         color: "#ffffff",
//                       }}
//                     >
//                       <tr>
//                         <th>#</th>
//                         <th>Mobile</th>
//                         <th>Name</th>
//                         <th>Gifted SQYD</th>
//                         <th>Date</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {data.length > 0 ? (
//                         data.map((item, index) => (
//                           <tr key={item.user_id || index}>
//                             <td>
//                               {(pagination.currentPage - 1) *
//                                 pagination.limit +
//                                 index +
//                                 1}
//                             </td>
//                             <td>{item.mobile || "N/A"}</td>
//                             <td>{item.username || "N/A"}</td>
//                             <td>{item.buysqrt || "N/A"}</td>
//                             <td>
//                               {item.date
//                                 ? new Date(item.date).toLocaleDateString(
//                                     "en-GB",
//                                   )
//                                 : "N/A"}
//                             </td>
//                           </tr>
//                         ))
//                       ) : (
//                         <tr>
//                           <td colSpan="5" className="text-center">
//                             No records found.
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </Table>

//                   {/* PAGINATION */}
//                   {pagination.totalPages > 1 && (
//                     <Pagination className="justify-content-end mt-3">
//                       <Pagination.Prev
//                         onClick={() =>
//                           handlePageChange(pagination.currentPage - 1)
//                         }
//                         disabled={pagination.currentPage === 1}
//                       />
//                       {[...Array(pagination.totalPages)].map((_, i) => (
//                         <Pagination.Item
//                           key={i + 1}
//                           active={i + 1 === pagination.currentPage}
//                           onClick={() => handlePageChange(i + 1)}
//                         >
//                           {i + 1}
//                         </Pagination.Item>
//                       ))}
//                       <Pagination.Next
//                         onClick={() =>
//                           handlePageChange(pagination.currentPage + 1)
//                         }
//                         disabled={
//                           pagination.currentPage === pagination.totalPages
//                         }
//                       />
//                     </Pagination>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>
//     </>
//   );
// }

// export default GiftSelfToAssociateList;
import React, { useEffect, useState } from "react";
import { Table, Spinner, Form, Button, Pagination } from "react-bootstrap";
import axios from "axios";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";

const API_URL = process.env.REACT_APP_API_URL;

// ─── Shared input style ───
const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
  transition: "all 0.2s ease",
  background: "#ffffff",
};

function GiftSelfToAssociateList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    mobile: "",
    bysqrt: "",
  });

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 20,
  });

  const [isFilterActive, setIsFilterActive] = useState(false);

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 FETCH DATA
  // ═══════════════════════════════════════════
  const fetchData = async (page = 1, filterData = filters) => {
    setLoading(true);
    const token = getAuthToken();

    if (!token) {
      alert("Authentication token not found.");
      setLoading(false);
      return;
    }

    try {
      const params = {
        page,
        limit: pagination.limit,
        mobile: filterData.mobile || "",
        buysqrt: filterData.bysqrt || "",
      };

      const response = await axios.get(
        `${API_URL}/gift-self-to-associate-list-given`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params,
        }
      );

      if (response.data.status === "1") {
        setData(response.data.data || []);
        setPagination((prev) => ({
          ...prev,
          currentPage: response.data.pagination.page,
          totalPages: response.data.pagination.totalPages,
          totalItems: response.data.pagination.total,
        }));
      } else {
        setData([]);
        setPagination((prev) => ({
          ...prev,
          currentPage: 1,
          totalPages: 1,
          totalItems: 0,
        }));
      }
    } catch (error) {
      console.error("API Error:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pagination.currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
    fetchData(1, filters);
  };

  const handleClearFilters = () => {
    setFilters({ mobile: "", bysqrt: "" });
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
    fetchData(1, { mobile: "", bysqrt: "" });
  };

  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const handlePageChange = (page) => {
    if (page > 0 && page <= pagination.totalPages) {
      setPagination((prev) => ({ ...prev, currentPage: page }));
    }
  };

  // ─── Pagination numbers ───
  const getPageNumbers = () => {
    const pages = [];
    const { currentPage, totalPages } = pagination;
    const showEllipsis = totalPages > 7;
    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");
    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);
    for (let i = start; i <= end; i++) pages.push(i);
    if (showEllipsis && currentPage < totalPages - 3)
      pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);
    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 RENDER
  // ═══════════════════════════════════════════
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          {/* ═══════ HEADER CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              padding: "24px 30px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "5px",
                background:
                  "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "16px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "26px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              🎁
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Self Gift To Associate
              </h1>
              <p
                style={{
                  margin: "3px 0 0",
                  fontSize: "13px",
                  color: "#64748b",
                  fontWeight: "500",
                }}
              >
                View all self gifts given to associates ({pagination.totalItems}{" "}
                total)
              </p>
            </div>

            {/* Filter Toggle */}
            <button
              onClick={handleToggle}
              title={isFilterActive ? "Hide Filters" : "Show Filters"}
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "10px",
                border: "1.5px solid #e2e8f0",
                background: isFilterActive ? "#1e5799" : "#ffffff",
                color: isFilterActive ? "#ffffff" : "#1e3a5f",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",
                cursor: "pointer",
                transition: "all 0.25s ease",
                boxShadow: isFilterActive
                  ? "0 6px 18px rgba(30, 87, 153, 0.3)"
                  : "none",
              }}
            >
              {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
            </button>
          </div>

          {/* ═══════ MAIN CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "24px 30px" }}>
              {/* ═══════ FILTER PANEL ═══════ */}
              {isFilterActive && (
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #f8fafc, #f0f6ff)",
                    border: "1.5px dashed #cbd5e1",
                    borderRadius: "14px",
                    padding: "20px",
                    marginBottom: "24px",
                  }}
                >
                  <Form onSubmit={handleFilterSubmit}>
                    <div
                      style={{
                        display: "flex",
                        gap: "12px",
                        flexWrap: "wrap",
                        alignItems: "flex-end",
                      }}
                    >
                      <div style={{ flex: 1, minWidth: "220px" }}>
                        <label
                          style={{
                            display: "block",
                            fontSize: "12px",
                            fontWeight: "700",
                            color: "#1e3a5f",
                            marginBottom: "6px",
                          }}
                        >
                          Mobile Number
                        </label>
                        <input
                          type="text"
                          name="mobile"
                          value={filters.mobile}
                          onChange={handleFilterChange}
                          placeholder="Search by Mobile"
                          style={inputStyle}
                        />
                      </div>
                      <div style={{ flex: 1, minWidth: "220px" }}>
                        <label
                          style={{
                            display: "block",
                            fontSize: "12px",
                            fontWeight: "700",
                            color: "#1e3a5f",
                            marginBottom: "6px",
                          }}
                        >
                          SQYD
                        </label>
                        <input
                          type="text"
                          name="bysqrt"
                          value={filters.bysqrt}
                          onChange={handleFilterChange}
                          placeholder="Search by SQYD"
                          style={inputStyle}
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          paddingBottom: "2px",
                        }}
                      >
                        <button
                          type="button"
                          onClick={handleClearFilters}
                          style={{
                            padding: "10px 20px",
                            borderRadius: "10px",
                            border: "1.5px solid #e2e8f0",
                            background: "#ffffff",
                            color: "#64748b",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Clear
                        </button>
                        <button
                          type="submit"
                          style={{
                            padding: "10px 24px",
                            borderRadius: "10px",
                            border: "none",
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                            color: "#ffffff",
                            fontSize: "13px",
                            fontWeight: "700",
                            cursor: "pointer",
                            boxShadow:
                              "0 4px 12px rgba(30, 87, 153, 0.3)",
                            whiteSpace: "nowrap",
                          }}
                        >
                          🔍 Search
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>
              )}

              {/* ═══════ TABLE ═══════ */}
              {loading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "70px 20px",
                    color: "#64748b",
                  }}
                >
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      border: "3px solid #cbd5e1",
                      borderTop: "3px solid #2b6cb0",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  <p
                    style={{
                      marginTop: "18px",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Loading data...
                  </p>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      overflowX: "auto",
                      overflowY: "visible",
                      borderRadius: "14px",
                      border: "1.5px solid #e2e8f0",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        minWidth: "700px",
                        borderCollapse: "collapse",
                        fontSize: "13px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                          }}
                        >
                          {["S.N", "Mobile", "Name", "Gifted SQYD", "Date"].map(
                            (th, i) => (
                              <th
                                key={i}
                                style={{
                                  padding: "14px 14px",
                                  color: "#ffffff",
                                  fontWeight: "700",
                                  fontSize: "11.5px",
                                  textAlign: "left",
                                  letterSpacing: "0.5px",
                                  textTransform: "uppercase",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {th}
                              </th>
                            )
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {data.length > 0 ? (
                          data.map((item, index) => (
                            <tr
                              key={item.user_id || index}
                              style={{ borderBottom: "1px solid #f1f5f9" }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background =
                                  "#f8fafc")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background =
                                  "transparent")
                              }
                            >
                              <td
                                style={{
                                  padding: "14px",
                                  fontWeight: "700",
                                  color: "#1e5799",
                                }}
                              >
                                {(pagination.currentPage - 1) *
                                  pagination.limit +
                                  index +
                                  1}
                              </td>
                              <td
                                style={{
                                  padding: "14px",
                                  color: "#334155",
                                  fontWeight: "600",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {item.mobile || "N/A"}
                              </td>
                              <td
                                style={{
                                  padding: "14px",
                                  color: "#1e3a5f",
                                  fontWeight: "600",
                                }}
                              >
                                {item.username || "N/A"}
                              </td>
                              <td style={{ padding: "14px" }}>
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px 14px",
                                    borderRadius: "20px",
                                    background:
                                      "linear-gradient(135deg, #f3e8ff, #e9d5ff)",
                                    color: "#7c3aed",
                                    fontWeight: "800",
                                    fontSize: "12.5px",
                                    border: "1.5px solid #d8b4fe",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  🎁 {item.buysqrt || "N/A"}
                                </span>
                              </td>
                              <td style={{ padding: "14px" }}>
                                <span
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    padding: "4px 12px",
                                    borderRadius: "20px",
                                    background:
                                      "linear-gradient(135deg, #e8f1fb, #dbeafe)",
                                    color: "#1e5799",
                                    fontSize: "12px",
                                    fontWeight: "700",
                                    border: "1.5px solid #bfdbfe",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  📅{" "}
                                  {item.date
                                    ? new Date(item.date).toLocaleDateString(
                                        "en-GB"
                                      )
                                    : "N/A"}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="5"
                              style={{
                                textAlign: "center",
                                padding: "60px 20px",
                                color: "#94a3b8",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              📭 No records found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* ═══════ PAGINATION ═══════ */}
                  {pagination.totalPages > 1 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "24px",
                        gap: "6px",
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        onClick={() =>
                          handlePageChange(pagination.currentPage - 1)
                        }
                        disabled={pagination.currentPage === 1}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color:
                            pagination.currentPage === 1
                              ? "#cbd5e1"
                              : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            pagination.currentPage === 1
                              ? "not-allowed"
                              : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        ‹ Prev
                      </button>

                      {getPageNumbers().map((p, i) => {
                        if (
                          p === "left-ellipsis" ||
                          p === "right-ellipsis"
                        ) {
                          return (
                            <span
                              key={`ellipsis-${i}`}
                              style={{
                                padding: "0 6px",
                                color: "#94a3b8",
                                fontWeight: "700",
                              }}
                            >
                              ...
                            </span>
                          );
                        }
                        const isActive = p === pagination.currentPage;
                        return (
                          <button
                            key={p}
                            onClick={() => handlePageChange(p)}
                            style={{
                              minWidth: "38px",
                              height: "38px",
                              borderRadius: "10px",
                              border: isActive
                                ? "none"
                                : "1.5px solid #e2e8f0",
                              background: isActive
                                ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                                : "#ffffff",
                              color: isActive ? "#ffffff" : "#334155",
                              fontWeight: "700",
                              fontSize: "13px",
                              cursor: "pointer",
                              boxShadow: isActive
                                ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                                : "none",
                              transition: "all 0.18s ease",
                            }}
                          >
                            {p}
                          </button>
                        );
                      })}

                      <button
                        onClick={() =>
                          handlePageChange(pagination.currentPage + 1)
                        }
                        disabled={
                          pagination.currentPage === pagination.totalPages
                        }
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color:
                            pagination.currentPage === pagination.totalPages
                              ? "#cbd5e1"
                              : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            pagination.currentPage === pagination.totalPages
                              ? "not-allowed"
                              : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        Next ›
                      </button>
                    </div>
                  )}

                  {data.length > 0 && (
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        color: "#94a3b8",
                        marginTop: "12px",
                        marginBottom: 0,
                        fontWeight: "500",
                      }}
                    >
                      Page {pagination.currentPage} of {pagination.totalPages} •{" "}
                      {pagination.totalItems} total records
                    </p>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default GiftSelfToAssociateList;